import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import update from 'immutability-helper';
import { Button, Container, Form, Segment } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { Route } from 'react-router-dom';
import feathersConnect from './../../../providers/feathersConnect';
import moment from 'moment';
import ReactTable from 'react-table';
import XLSX from 'xlsx';
import { snakeCase } from 'lodash';

const PAGE_RANGE = 10;

const INITIAL_STATE = {
  libros: {
    loading: false,
    data: [],
    error: null
  },
  cooperativas: {
    loading: false,
    data: [],
    error: null
  },
  filter: {
    CooperativaId: null,
    since: moment().startOf('year').format('YYYY-MM-DD'),
    until: moment().endOf('month').format('YYYY-MM-DD')
  }
};

class InformeLibrosView extends Component {

  constructor (props) {
    super(props);

    this.state = INITIAL_STATE;

    this.CooperativaService = this.props.feathers.service('/api/cooperativas');
    this.LibroService = this.props.feathers.service('/api/libros');
  }

  findCooperativas = (cb) => {
    this.setState(update(this.state, {
      cooperativas: {
        $merge: {
          loading: true
        }
      }
    }));

    this.CooperativaService.find({ query: { limit: 99999 }})
      .then(response => {
        this.setState(update(this.state, {
          cooperativas: {
            $merge: {
              loading: false,
              data: response.records
            }
          }
        }), () => {
          cb();
        });
      })
      .catch(error => {
        this.setState(update(this.state, {
          cooperativas: {
            $merge: {
              loading: false,
              error
            }
          }
        }), () => {
          cb();
        });
      });
  }

  mapCooperativasToOptions = (cooperativas) => {
    return [{ key: 0, text: 'NINGUNA', value: '' }].concat(cooperativas.map(cooperativa => ({
      key: cooperativa.id,
      text: `MN: ${cooperativa.matriculaNacional} MP: ${cooperativa.matriculaProvincial} ${cooperativa.nombre}`,
      value: cooperativa.id
    })));
  }

  findLibros = () => {
    let { filter } = this.state;

    this.setState(update(this.state, {
      libros: {
        $merge: {
          loading: true
        }
      }
    }));

    this.LibroService.find({ query: filter })
      .then(response => {
        this.setState(update(this.state, {
          libros: {
            $merge: {
              loading: false,
              data: response.records
            }
          }
        }));
      })
      .catch(error => {
        this.setState(update(this.state, {
          libros: {
            $merge: {
              loading: false,
              error
            }
          }
        }));
      });
  }

  downloadXLSX = () => {
    let { libros: { data } } = this.state;

    let wb = XLSX.utils.book_new();
    let ws = XLSX.utils.json_to_sheet(data.map(r => ({
      'Matricula Nacional': r.cooperativa.matriculaNacional,
      Cooperativa: r.cooperativa.nombre,
      Concepto: r.concepto,
      Nro: r.nro,
      Fecha: moment(r.fecha).format('DD/MM/YYYY')
    })));

    XLSX.utils.book_append_sheet(wb, ws, 'Hoja1');

    XLSX.writeFile(wb, `libros.xlsx`);
  }

  filterInputHandler = (e, input) => {
    this.setState(update(this.state, {
      filter: {
        $merge: {
          [input.name]: input.value
        }
      }
    }));
  }

  componentDidMount () {
    this.findCooperativas(this.findLibros);
  }

  static mapStateToProps (state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps (dispatch) {
    return {
      navigate: (path) => {
        dispatch(push(path));
      }
    };
  }

  render () {
    let { cooperativas, libros, filter } = this.state;

    return (
      <Container>
        <Segment>
          <Form>
            <Form.Group>
              <Form.Input
                label="Desde" name="since" type="date"
                value={filter.since} onChange={this.filterInputHandler} />
              <Form.Input
                label="Hasta" name="until" type="date"
                value={filter.until} onChange={this.filterInputHandler} />
            </Form.Group>
            <Form.Group>
              <Form.Select
                label={cooperativas.loading ? 'Cargando...' : 'Cooperativa'} name="CooperativaId" options={this.mapCooperativasToOptions(cooperativas.data)}
                loading={cooperativas.loading} disabled={cooperativas.loading} search
                value={filter.CooperativaId} onChange={this.filterInputHandler} width={10} />
            </Form.Group>
          </Form>
        </Segment>
        <Segment clearing>
          <Button content="Refrescar" disabled={libros.loading} icon="refresh" positive onClick={this.findLibros} />
          <Button content="Descargar XLSX" disabled={libros.loading} icon="download" floated="right" onClick={this.downloadXLSX} />
        </Segment>
        <ReactTable
          className="-striped -highlight"
          loading={libros.loading} data={libros.data}
          defaultPageSize={10}
          columns={[
            {
              Header: 'Matricula Nacional',
              id: 'matriculaNacional',
              accessor: d => d.cooperativa.matriculaNacional
            },
            {
              Header: 'Cooperativa',
              id: 'cooperativa',
              accessor: d => d.cooperativa.nombre
            },
            {
              Header: 'Concepto',
              accessor: 'concepto'
            },
            {
              Header: 'Nro',
              accessor: 'nro',
              width: 64
            },
            {
              Header: 'Fecha',
              id: 'fecha',
              accessor: d => {
                let date = moment(d.fecha);

                date.parseZone();
                return date.format('DD/MM/YYYY');
              }
            }
          ]}
          previousText="Anterior"
          nextText="Siguiente"
          loadingText="Cargando..."
          noDataText="Sin Registros"
          pageText="Pagina"
          ofText="de"
          rowsText="filas" />
      </Container>
    );
  }
}

export default feathersConnect(
  connect(
    InformeLibrosView.mapStateToProps,
    InformeLibrosView.mapDispatchToProps
  )(InformeLibrosView)
);



// WEBPACK FOOTER //
// ./client/components/pages/informes/InformeLibrosView.js